import React, { useState, useMemo, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import Filter from './Filter'
import { ExpandableBlocks, ContentBlock, ContentBlockLoading, ExpandableContext } from 'components/ContentBlock'
import DxDataTable from 'components/DxDataTable'
import getTableCols from './columns'
import useLocale from 'hooks/useLocale'
import { useStatisticsData } from '../helpers'
import { initCustomerFrequencies, getStatisticsData } from '../../gql/getCustomerFrequencies'

const CustomerActivity = () => {
	const [creditCols, setCreditCols] = useState()
	const [t] = useTranslation()
	const locales = useLocale()
	const timeInterval = useRef()
	const tableCols = useMemo(() => getTableCols({ t, locales, showInterval: timeInterval.current, creditCols }), [t, locales, timeInterval.current, creditCols])

	const { getStatistics, status, data, loading, called } = useStatisticsData({
		getQuery: getStatisticsData,
		initQuery: initCustomerFrequencies
	})

	const handleGetCustomerFrequencies = setExpandedId => vals => {
		getStatistics({ variables: { params: vals } })
		timeInterval.current = vals?.timeCheck
		setExpandedId('2')
	}

	return(
		<ExpandableBlocks>
			<ExpandableContext.Consumer>
				{({ setExpandedId }) => (
					<>
						<ContentBlock label={t('common.strings.settings')} startExpanded>
							<Filter
								onFilter={handleGetCustomerFrequencies(setExpandedId)}
								creditVal={creditCols}
								onChangeCredit={setCreditCols}
							/>
						</ContentBlock>
						{called &&
							<ContentBlockLoading
								isLoading={loading}
								topBorder
								alwaysExpanded
								blockId='2'
							>
								<DxDataTable
									data={data}
									height={600}
									columns={tableCols}
									label={t('statistic_section.sub_sections.customer_activity')}
									excelExport
									{...timeInterval.current && { groupBy: ['dateTime'] }}
									{...status === 'ERROR' && { noDataText: t('server_errors.request_failed') }}
								/>
							</ContentBlockLoading>
						}
					</>
				)}
			</ExpandableContext.Consumer>
		</ExpandableBlocks>
	)
}

export default CustomerActivity
